import React, {Component} from 'react'
import NewsFeedBase from './news-feed-base';

import './news-feed.css'

class NewsFeed extends Component {
    render(){
        return(
            <NewsFeedBase {...this.props} whitlelabelPrefix = "" platformID="1"/>
        );
    }
}

export default NewsFeed;


// WEBPACK FOOTER //
// ./src/components/containers/play-screen/news-feed/news-feed.js